import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "moment/locale/pt-br";
import "./index.css";

ReactDOM.render(
  <Router basename="/gestaodeponto">
    <App />
  </Router>,
  document.getElementById("root"),
);

serviceWorker.unregister();
